export default {
  title: 'Datos generales',
  document: 'NIE/CIF',
  reason: 'Razón Social',
  email: 'Correo Electrónico',
  address: 'Dirección',
  postalCode: 'Código Postal',
  town: 'Población',
  city: 'Provincia',
  country: 'País',
  inscription: 'Inscripción Reg. Mercantil',
  accountAssignedId: 'Código Cuenta Contable',
  irpf: {
    retention: 'Retención IRPF',
    notSupported: 'No soporta IRPF'
  },
  greenPoint: {
    label: 'Punto Verde',
    notSupported: 'No soportado',
    included: 'Incluido en el importe',
    brokenDown: 'Desglosado a nivel de línea'
  },
  subjectTo: 'Sujeto al Régimen Especial de Criterio de Caja',
  help: 'Empresa sujeta al Régimen Especial de Criterio de Caja, de acuerdo al Art. 23 de la Ley 14/2013',
  ticketbaiRequired: 'Notificar a TicketBAI',
  headingBizkaia: 'Epígrafe',
  headingListBizkaia: 'Descargar listado de epígrafes',
  ticketbaiRequiredHelp: 'Norma Foral 13/2021, de 21 de abril (Álava). Norma Foral 3/2020, de 6 de noviembre (Guipúzcoa), Norma Foral 8/2023, de 22 de noviembre (Vizcaya)',
  siiRequired: 'Notificar al SII (LRFE)',
  siiRequiredHelp: `<br>El período de liquidación de registro en el SII, se corresponderá con el año y mes de la fecha de devengo de la factura. <br>La fecha de expedición y de registro en el SII será la fecha de emisión de la factura.`,
  modal: {
    text: 'Los datos han sido actualizados con éxito.'
  },
  terms: 'Términos y condiciones del contrato',
  version: {
    title: 'Sistema Efactura',
    front: 'Versión Front: ',
    core: 'Versión Core: ',
    back: 'Versión API: '
  }
}
